module.exports = __webpack_public_path__ + "public/images/banner_bg.4a7e00ea8271e3ee335b9286f80bfef3.webp";